import Vue from 'vue'
import Router from 'vue-router'
// ----------------------------------------
import GPS from '@/components/myComponents/GPS'
import MobileActive from '@/components/myComponents/MobileActive'
import MobileReadActive from '@/components/myComponents/MobileReadActive'

import Support from '@/components/Support'
import Login from '@/components/Login'
import SiteUnderMaintenance from '@/components/SiteUnderMaintenance'
import ChangePassword from '@/components/ChangePassword'
import ComInfo from '@/components/company/ComInfo'
import Branches from '@/components/company/Branches'
import Branch from '@/components/company/Branch'
import UserGroups from '@/components/company/UserGroups'
import Permissions from '@/components/company/Permissions'
import Governorates from '@/components/company/Governorates'
import Cities from '@/components/company/Cities'
import Jobs from '@/components/company/Jobs'
import Regions from '@/components/company/Regions'
import Villages from '@/components/company/Villages'
import PermissionItems from '@/components/company/PermissionItems'
import Departments from '@/components/company/Departments'
import Assets from '@/components/company/Assets'
import ManufacturingComponents from '@/components/company/ManufacturingComponents'
import FreePics from '@/components/company/FreePics'
import ReceiptFolders from '@/components/company/ReceiptFolders'
import GoogleMap from '@/components/company/GoogleMap'

import Employees from '@/components/employees/Employees'
import EmpItineraries from '@/components/employees/EmpItineraries'
import SalaryMovement from '@/components/employees/SalaryMovement'
import Advances from '@/components/employees/Advances'
import Payroll from '@/components/employees/Payroll'
import Bonus from '@/components/employees/Bonus'
import ReportTellerUsers from '@/components/employees/ReportTellerUsers'
import TecReport from '@/components/Sales/Reports/TecReport'
import CustomrReviewRep from '@/components/Reports/CustomrReviewRep'
import ChangeProfile from '@/components/employees/ChangeProfile'
import UserCallLog from '@/components/employees/UserCallLog'
import EmpPayrollDetails from '@/components/employees/EmpPayrollDetails'

import Items from '@/components/company/Items'
import ItemPrices from '@/components/purchases/ItemPrices'
import MaintenanceItems from '@/components/company/MaintenanceItems'
import Vendors from '@/components/purchases/Vendors'
import VendorsMovements from '@/components/purchases/VendorsMovements'
import DeliveryTicket from '@/components/purchases/DeliveryTicket'
import PostDeliveryTicket from '@/components/purchases/PostDeliveryTicket'
import ReturnPurchaseTickets from '@/components/purchases/ReturnPurchaseTickets'
import PostReturnPurchaseTickets from '@/components/purchases/PostReturnPurchaseTickets'
import PosTransferBranch from '@/components/purchases/PosTransferBranch'
import TransferBranchMasters from '@/components/purchases/TransferBranchMasters'
import ReceiptBranchTransfer from '@/components/purchases/ReceiptBranchTransfer'
import Manufacturing from '@/components/purchases/Manufacturing'
import FirstBalance from '@/components/purchases/FirstBalance'
import ItemCard from '@/components/purchases/ItemCard'
import StockMovementRep from '@/components/purchases/StockMovementRep'

import Stores from '@/components/purchases/Stores'
import StoreMovments from '@/components/purchases/StoreMovments'
import Stocktaking from '@/components/purchases/Stocktaking'
import Treasuries from '@/components/Accounts/Treasuries'
import TreasuryMovments from '@/components/Accounts/TreasuryMovments'
import ExpenseTypes from '@/components/company/ExpenseTypes'
import RecordRevenueExpenses from '@/components/Accounts/RecordRevenueExpenses'
import TreasuryReport from '@/components/Accounts/TreasuryReport'
import DailyAccounts from '@/components/Accounts/DailyAccounts'
import DailyAccounts1 from '@/components/Accounts/Daily/DailyAccounts'
import ReceiptAuthorization from '@/components/Accounts/Daily/ReceiptAuthorization'
import DailyReview from '@/components/Accounts/Daily/DailyReview'
import DailyReview1 from '@/components/Accounts/Daily/DailyReview1'
import Lines from '@/components/Sales/Lines'
import Customers from '@/components/Sales/Customers'
import MaintenanceStatement from '@/components/Sales/MaintenanceStatement'
import CollectingStatement from '@/components/Sales/CollectingStatement'
import CreateCollectingstatement from '@/components/Sales/CreateCollectingstatement'
import PrintCollectingstatement from '@/components/Sales/PrintCollectingstatement'
import CollectingSheet from '@/components/Sales/CollectingSheet'
import MaintenanceGroups from '@/components/Sales/MaintenanceGroups'
import DirectSales from '@/components/Sales/DirectSales'
import Settlementcollectorsaccounts from '@/components/Sales/Settlementcollectorsaccounts'
import Offers from '@/components/Sales/Offers'
import Folders from '@/components/Sales/Folders'
import CreateReceipts from '@/components/Sales/CreateReceipts'
import SalesReturns from '@/components/Sales/SalesReturns'
import CreateFolders from '@/components/Sales/CreateFolders'

import MaintenanceArrears from '@/components/Sales/Reports/MaintenanceArrears'
import LastMaintenance from '@/components/Sales/Reports/LastMaintenance'
import InstallmentsArrears from '@/components/Sales/Reports/InstallmentsArrears'
import OffersInstallmentsArrears from '@/components/Sales/Reports/OffersInstallmentsArrears'
import CreateMaintenanceStatement from '@/components/Sales/CreateMaintenanceStatement'
import Maintenancestatement1 from '@/components/Sales/Maintenancestatement1'
import Sessions from '@/components/Settings/Sessions'
import UsersActivity from '@/components/Settings/UsersActivity'
import CustomerActivity from '@/components/Settings/CustomerActivity'

// ----------------------------------------
import Rep01 from '@/components/Reports/Rep01'
import Rep02 from '@/components/Reports/Rep02'
import BranchPerformance from '@/components/Reports/BranchPerformance'
import AllUsersCallLog from '@/components/Reports/AllUsersCallLog'
import GetBranchReceiptsStatus from '@/components/Reports/GetBranchReceiptsStatus'
import IncomingStore from '@/components/Reports/IncomingStore'
import Withoutoffers from '@/components/Reports/Withoutoffers'
// ----------------------------------------
import Home from '@/components/Home'
import DashBoard from '@/components/DashBoard'

// import FloatCharts from '@/components/charts/FloatCharts'
// import MorrisCharts from '@/components/charts/MorrisCharts'
//
// import Forms from '@/components/Forms'
// import Tables from '@/components/Tables'
//
// import Buttons from '@/components/ui-elements/Buttons'
// import Grid from '@/components/ui-elements/Grid'
// import Icons from '@/components/ui-elements/Icons'
// import Notifications from '@/components/ui-elements/Notifications'
// import Panels from '@/components/ui-elements/Panels'
// import Typography from '@/components/ui-elements/Typography'
//
import Invoices from '@/components/Invoices/Invoices'
import Distribution from '@/components/Invoices/Distribution'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/login', name: 'Login', component: Login },
    { path: '/siteundermaintenance', name: 'SiteUnderMaintenance', component: SiteUnderMaintenance },
    { path: '/gps', name: 'GPS', component: GPS },
    { path: '/mobileactive', name: 'MobileActive', component: MobileActive },
    { path: '/mobilereadactive', name: 'MobileReadActive', component: MobileReadActive },
    { path: '/',
      name: 'Home',
      component: Home,
      beforeEnter: (to, from, next) => {
        if (sessionStorage.getItem('isLogin')) {
          next()
        } else {
          next('/login')
        }
      },
      children: [
        // ----------------------------------------
        { path: '/cominfo', name: 'ComInfo', component: ComInfo },
        { path: '/branches', name: 'Branches', component: Branches },
        { path: '/branch', name: 'Branch', component: Branch },
        { path: '/usergroups', name: 'UserGroups', component: UserGroups },
        { path: '/permissions', name: 'Permissions', component: Permissions },
        { path: '/governorates', name: 'Governorates', component: Governorates },
        { path: '/cities', name: 'Cities', component: Cities },
        { path: '/jobs', name: 'Jobs', component: Jobs },
        { path: '/regions', name: 'Regions', component: Regions },
        { path: '/villages', name: 'Villages', component: Villages },
        { path: '/permissionitems', name: 'PermissionItems', component: PermissionItems },
        { path: '/departments', name: 'Departments', component: Departments },
        { path: '/assets', name: 'Assets', component: Assets },
        { path: '/manufacturingcomponents', name: 'ManufacturingComponents', component: ManufacturingComponents },
        { path: '/firstbalance', name: 'FirstBalance', component: FirstBalance },
        { path: '/itemcard', name: 'ItemCard', component: ItemCard },
        { path: '/stockmovementrep', name: 'StockMovementRep', component: StockMovementRep },
        { path: '/support', name: 'Support', component: Support },
        { path: '/freepics', name: 'FreePics', component: FreePics },
        { path: '/receiptfolders', name: 'ReceiptFolders', component: ReceiptFolders },
        { path: '/googlemap', name: 'GoogleMap', component: GoogleMap },
        { path: '/createreceipts', name: 'CreateReceipts', component: CreateReceipts },
        { path: '/salesreturns', name: 'SalesReturns', component: SalesReturns },

        { path: '/employees', name: 'Employees', component: Employees },
        { path: '/empitineraries', name: 'EmpItineraries', component: EmpItineraries },
        { path: '/changepassword', name: 'ChangePassword', component: ChangePassword, meta: {requiresAuth: true} },
        { path: '/tellerUsersReport', name: 'tellerUsersReport', component: ReportTellerUsers, meta: {requiresAuth: true} },
        { path: '/tecReport', name: 'TecReport', component: TecReport, meta: {requiresAuth: true} },
        { path: '/customrreviewrep', name: 'CustomrReviewRep', component: CustomrReviewRep, meta: {requiresAuth: true} },

        { path: '/salarymovement', name: 'SalaryMovement', component: SalaryMovement },
        { path: '/advances', name: 'Advances', component: Advances },
        { path: '/payroll', name: 'Payroll', component: Payroll },
        { path: '/bonus', name: 'Bonus', component: Bonus },
        { path: '/changeprofile', name: 'ChangeProfile', component: ChangeProfile },
        { path: '/userCallLog', name: 'UserCallLog', component: UserCallLog },
        { path: '/userpayrolldetails', name: 'EmpPayrollDetails', component: EmpPayrollDetails },

        { path: '/items', name: 'Items', component: Items },
        { path: '/itemprices', name: 'ItemPrices', component: ItemPrices },
        { path: '/maintenanceItem', name: 'MaintenanceItems', component: MaintenanceItems },
        { path: '/vendors', name: 'Vendors', component: Vendors },
        { path: '/vendorsmovements', name: 'VendorsMovements', component: VendorsMovements },
        { path: '/deliveryticket', name: 'DeliveryTicket', component: DeliveryTicket },
        { path: '/postdeliveryticket', name: 'PostDeliveryTicket', component: PostDeliveryTicket },
        { path: '/teturnpurchasetickets', name: 'ReturnPurchaseTickets', component: ReturnPurchaseTickets },
        { path: '/postreturnpurchasetickets', name: 'PostReturnPurchaseTickets', component: PostReturnPurchaseTickets },
        { path: '/postransferbranch', name: 'PosTransferBranch', component: PosTransferBranch },
        { path: '/transferbranchmasters', name: 'TransferBranchMasters', component: TransferBranchMasters },
        { path: '/receiptbranchtransfer', name: 'ReceiptBranchTransfer', component: ReceiptBranchTransfer },
        { path: '/stores', name: 'Stores', component: Stores },
        { path: '/storemovments', name: 'StoreMovments', component: StoreMovments },
        { path: '/stocktaking', name: 'Stocktaking', component: Stocktaking },
        { path: '/manufacturing', name: 'Manufacturing', component: Manufacturing },

        { path: '/treasuries', name: 'Treasuries', component: Treasuries },
        { path: '/treasurymovments', name: 'TreasuryMovments', component: TreasuryMovments },
        { path: '/expensetypes', name: 'ExpenseTypes', component: ExpenseTypes },
        { path: '/recordrevenueexpenses', name: 'RecordRevenueExpenses', component: RecordRevenueExpenses },
        { path: '/treasuryreport', name: 'TreasuryReport', component: TreasuryReport },
        { path: '/dailyaccounts', name: 'DailyAccounts', component: DailyAccounts },
        { path: '/dailyaccounts1', name: 'DailyAccounts1', component: DailyAccounts1 },
        { path: '/receiptauthorization', name: 'ReceiptAuthorization', component: ReceiptAuthorization },
        { path: '/dailyreview', name: 'DailyReview', component: DailyReview },
        { path: '/dailyreview1', name: 'DailyReview1', component: DailyReview1 },

        { path: '/lines', name: 'Lines', component: Lines },
        { path: '/customers', name: 'Customers', component: Customers },
        { path: '/collectingstatement', name: 'CollectingStatement', component: CollectingStatement },
        { path: '/createCollectingstatement', name: 'CreateCollectingstatement', component: CreateCollectingstatement },
        { path: '/createmaintenancestatement', name: 'CreateMaintenanceStatement', component: CreateMaintenanceStatement },
        { path: '/printCollectingstatement', name: 'PrintCollectingstatement', component: PrintCollectingstatement },
        { path: '/maintenancestatement', name: 'MaintenanceStatement', component: MaintenanceStatement },
        { path: '/maintenancestatement1', name: 'Maintenancestatement1', component: Maintenancestatement1 },
        { path: '/maintenancegroups', name: 'MaintenanceGroups', component: MaintenanceGroups },
        { path: '/collectingsheet', name: 'CollectingSheet', component: CollectingSheet },
        { path: '/settlementcollectorsaccounts', name: 'Settlementcollectorsaccounts', component: Settlementcollectorsaccounts },
        { path: '/offers', name: 'Offers', component: Offers },
        { path: '/folders', name: 'Folders', component: Folders },
        { path: '/maintenancearrears', name: 'MaintenanceArrears', component: MaintenanceArrears },
        { path: '/lastmaintenance', name: 'LastMaintenance', component: LastMaintenance },
        { path: '/installmentsarrears', name: 'InstallmentsArrears', component: InstallmentsArrears },
        { path: '/offers-installments-arrears', name: 'OffersInstallmentsArrears', component: OffersInstallmentsArrears },
        { path: '/directsales', name: 'DirectSales', component: DirectSales },
        { path: '/sessions', name: 'Sessions', component: Sessions },
        { path: '/usersactivity', name: 'UsersActivity', component: UsersActivity },
        { path: '/customeractivity', name: 'CustomerActivity', component: CustomerActivity },
        { path: '/createfolders', name: 'CreateFolders', component: CreateFolders },

        // ----------------------------------------
        { path: '/rep01', name: 'Rep01', component: Rep01 },
        { path: '/rep02', name: 'Rep02', component: Rep02 },
        { path: '/branchperformance', name: 'BranchPerformance', component: BranchPerformance },
        { path: '/allusersCallLog', name: 'AllUsersCallLog', component: AllUsersCallLog },
        { path: '/getbranchreceiptsstatus', name: 'GetBranchReceiptsStatus', component: GetBranchReceiptsStatus },
        { path: '/incomingstore', name: 'IncomingStore', component: IncomingStore },
        { path: '/withoutoffers', name: 'Withoutoffers', component: Withoutoffers },
        // ----------------------------------------
        { path: '/dashborad', name: 'DashBoard', component: DashBoard },

        // { path: '/float', name: 'FloatCharts', component: FloatCharts },
        // { path: '/morris', name: 'MorrisCharts', component: MorrisCharts },
        //
        // { path: '/tables', name: 'Tables', component: Tables },
        // { path: '/forms', name: 'Forms', component: Forms },
        //
        // { path: '/buttons', name: 'Buttons', component: Buttons },
        // { path: '/grid', name: 'Grid', component: Grid },
        // { path: '/icons', name: 'Icons', component: Icons },
        // { path: '/notifications', name: 'Notifications', component: Notifications },
        // { path: '/panels', name: 'Panels', component: Panels },
        // { path: '/typography', name: 'Typography', component: Typography },
        // -------------------------------------------------
        { path: '/invoices', name: 'Invoices', component: Invoices },
        { path: '/distribution', name: 'Distribution', component: Distribution },
        // ==================================================================
        // ==================================================================
        // ==================================================================
        // ==================================================================
        // ==================================================================
        // ==================================================================
        {
          path: '/new-customers',
          name: 'Customers',
          component: () => import('@/components/Sales/Customers/Customers')
        },
        {
          path: '/create-invoice',
          name: 'CreateInvoice',
          component: () => import('@/components/Sales/Invoice/CreateInvoice')
        },
        {
          path: '/offer-deals',
          name: 'OfferDeals',
          component: () => import('@/components/Sales/OfferDeals')
        }
      ]
    }
  ]
})

// router.replace({ path: '/login', redirect: '/login' })
export default router



// WEBPACK FOOTER //
// ./src/router/index.js